var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper"},[_c('iframe',{attrs:{"name":"swiperPage","src":"http://no59.art:8002/","width":"100%","height":"100%"}})])}]

export { render, staticRenderFns }